module.exports = __webpack_public_path__ + "img/5e4f4cacc1193da49ec8f76f5a2f2833.png";